import React from "react";
import { Spin } from "antd";
import "./index.css";

function Loader({report}) {
  return (
    <>
    <div className="loader-wrapper">
      <Spin size="large" />
    </div>
    {report &&
    <div className="loader-wrapper-text">
        Отчет генерируется!
    </div>

    
    }
      </>
  );
}

export default Loader;
